import { Form } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import {
	Field,
	FieldDescription,
	FieldGroup,
	FieldLabel,
} from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface RegistrationFormProps {
	className?: string;
	errors?: Record<string, string[]>;
}

export function RegistrationForm({ className, errors }: RegistrationFormProps) {
	return (
		<Form
			action="/sign_up"
			method="post"
			disableWhileProcessing
			className={cn("flex flex-col gap-6", className)}
		>
			<FieldGroup>
				<div className="flex flex-col items-center gap-1 text-center">
					<h1 className="font-bold text-2xl">Registrace povinné osoby</h1>
					<p className="text-balance text-muted-foreground text-sm">
						Vyplňte údaje níže pro vytvoření nového účtu
					</p>
				</div>

				<Field>
					<FieldLabel htmlFor="ico">IČO</FieldLabel>
					<Input
						id="ico"
						name="ico"
						type="text"
						placeholder="12345678"
						aria-invalid={!!errors?.ico}
						required
					/>
					{errors?.ico && (
						<FieldDescription className="text-destructive">
							{errors.ico.join(", ")}
						</FieldDescription>
					)}
				</Field>

				<Field>
					<FieldLabel htmlFor="company_name">Název povinné osoby</FieldLabel>
					<Input
						id="company_name"
						name="company_name"
						type="text"
						placeholder="Acme Accounting s.r.o."
						aria-invalid={!!errors?.name}
						required
					/>
					{errors?.name && (
						<FieldDescription className="text-destructive">
							{errors.name.join(", ")}
						</FieldDescription>
					)}
				</Field>

				<Field>
					<FieldLabel htmlFor="email">Email</FieldLabel>
					<Input
						id="email"
						name="email"
						type="email"
						placeholder="jan.novak@example.com"
						aria-invalid={!!errors?.email}
						required
					/>
					{errors?.email && (
						<FieldDescription className="text-destructive">
							{errors.email.join(", ")}
						</FieldDescription>
					)}
				</Field>

				<Field>
					<FieldLabel htmlFor="password">Heslo</FieldLabel>
					<Input
						id="password"
						name="password"
						type="password"
						aria-invalid={!!errors?.password}
						required
						autoComplete="new-password"
					/>
					{errors?.password && (
						<FieldDescription className="text-destructive">
							{errors.password.join(", ")}
						</FieldDescription>
					)}
				</Field>

				<Field>
					<FieldLabel htmlFor="password_confirmation">
						Potvrzení hesla
					</FieldLabel>
					<Input
						id="password_confirmation"
						name="password_confirmation"
						type="password"
						aria-invalid={!!errors?.password_confirmation}
						required
						autoComplete="new-password"
					/>
					{errors?.password_confirmation && (
						<FieldDescription className="text-destructive">
							{errors.password_confirmation.join(", ")}
						</FieldDescription>
					)}
				</Field>

				<Field>
					<Button type="submit" className="w-full">
						Registrovat se
					</Button>
				</Field>

				<Field>
					<FieldDescription className="text-center">
						Již máte účet?{" "}
						<a href="/sign_in" className="underline underline-offset-4">
							Přihlásit se
						</a>
					</FieldDescription>
				</Field>
			</FieldGroup>
		</Form>
	);
}
